const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto', style: 'short' });
const num = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 });

/** "just now", "5 min. ago", "3 hr. ago", "2 days ago"... */
export function timeAgo(ms: number, now: number): string {
  const s = Math.round((now - ms) / 1000);
  if (s < 45) return 'just now';
  const m = Math.round(s / 60);
  if (m < 60) return rtf.format(-m, 'minute');
  const h = Math.round(m / 60);
  if (h < 24) return rtf.format(-h, 'hour');
  const d = Math.round(h / 24);
  if (d < 30) return rtf.format(-d, 'day');
  return new Date(ms).toLocaleDateString();
}

export function formatDistance(km: number | null): string | null {
  if (km === null) return null;
  if (km < 1) return 'under 1 km away';
  return `${num.format(km < 10 ? Math.round(km) : Math.round(km / 5) * 5)} km away`;
}

export function domainOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

/** The tooltip on a post: its headline is already showing, so say what a click does. */
export const READ_MORE = 'Click to read more';
